var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user.loading)?_c('w-loader'):_vm._e(),_c('div',{ref:"widget_container",staticClass:"widget-holder h-100 w-100",attrs:{"data-test-id":"iotum-widget"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }